import { stripHtmlToText } from 'utils/helpers/functions/stripHtml';

interface RowTitleProps {
    name: string;
    description?: string | null;
    onNameClick?: () => void;
}

const RowTitle = ({ name, description, onNameClick }: RowTitleProps) => {
    const plain = stripHtmlToText(description || '');

    return (
        <div className="row-title">
            {onNameClick ? (
                <div
                    className="row-title__name fw-semibold text-body text-truncate cursor-pointer"
                    role="button"
                    tabIndex={0}
                    title={name || undefined}
                    onClick={onNameClick}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter' || event.key === ' ') {
                            event.preventDefault();
                            onNameClick();
                        }
                    }}
                >
                    {name}
                </div>
            ) : (
                <div className="row-title__name fw-semibold text-body text-truncate" title={name || undefined}>
                    {name}
                </div>
            )}
            {plain ? (
                <div className="text-muted fs-12 text-truncate" title={plain}>
                    {plain}
                </div>
            ) : null}
        </div>
    );
};

export default RowTitle;
